import React, { useState, useEffect, useCallback } from "react";
import { Button, Form, FormTextArea, Image, Loader } from "semantic-ui-react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import $ from "jquery";

import serverName from "../../functions/server";

const Generate = (props) => {
  const [dialog, setDialog] = useState(false);
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [text, setText] = useState("Generating Text...");
  const [load, setLoad] = useState(false);

  const generateText = useCallback(() => {
    let php =
      props.type === "description"
        ? props.type
        : props.type === "image"
        ? "image"
        : "longdescription";
    let server = serverName() + `/generative/${php}.php`;
    let data = {
      title: props.title,
    };
    if (props.type === "image") {
      data = {
        text: description,
      };
    }
    setLoad(true);
    $.ajax({
      type: "POST",
      data: data,
      url: server,
      success: function (data) {
        setLoad(false);
        data = JSON.parse(data);
        if (props.type === "image") {
          let temp = data[0].inlineData;
          if (data[1].inlineData) {
            temp = data[1].inlineData;
          }
          setImage(`data:${temp.mimeType};base64,${temp.data}`);
          return;
        }
        setText(data.text);
      },
      error: function (data, status) {
        setText(data);
      },
    });
  }, [props.title, props.type, description]);

  useEffect(() => {
    if (dialog && props.type !== "image") {
      generateText();
    }
  }, [props.type, dialog, generateText]);

  const downloadURI = (uri, name) => {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Button
        basic
        color="blue"
        style={{ margin: 10 }}
        content="Generate with AI"
        size="mini"
        onClick={() => setDialog(true)}
      />
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={dialog}
        onClose={() => setDialog(false)}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogContent>
          {props.type === "image" && (
            <Form>
              <FormTextArea
                fluid
                label="Image Description"
                onChange={(event) => setDescription(event.target.value)}
                value={description}
              />
            </Form>
          )}
          {props.type !== "image" && text && !load ? (
            <p
              dangerouslySetInnerHTML={{
                __html: text.includes("http-equiv") ? "" : text ? text : "",
              }}
            />
          ) : null}
          {props.type === "image" && image.length > 100 && !load && (
            <Image
              src={image}
              fluid
              id="image"
              style={{ width: "30%", height: "30%", marginTop: 10 }}
            />
          )}
          {load && <Loader active inline style={{ marginTop: 10 }} />}
        </DialogContent>
        <DialogActions>
          {props.type !== "image" && (
            <Button
              primary
              onClick={() => {
                setDialog(false);
                props.setValue(props.type, text);
              }}
            >
              Use This
            </Button>
          )}
          {props.type === "image" && (
            <Button
              primary
              onClick={() => {
                generateText();
              }}
            >
              Generate Image
            </Button>
          )}
          {props.type === "image" && image.length > 100 && (
            <Button
              primary
              onClick={() => {
                downloadURI(image, props.title + ".png");
              }}
            >
              Download Image
            </Button>
          )}
          <Button color="red" onClick={() => setDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Generate;
